import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { OrderCreationRequirements, Store, StoresService } from 'src/app/core/stores.service';

@Component({
  selector: 'app-stores-toggle-dialog',
  templateUrl: './stores-toggle-dialog.component.html',
  styleUrls: ['./stores-toggle-dialog.component.scss'],
})
export class StoresToggleDialogComponent {
  store?: Store;
  is_enabling_running: boolean = false;
  store_order_requirements_from_group: FormGroup = this.form_service.store_order_requirements_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(
    private dialog_ref: MatDialogRef<StoresToggleDialogComponent>,
    private form_service: FormService,
    private stores_service: StoresService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.store = data.store;
  }

  ngOnInit(): void {
    if (this.store) {
      const is_enabled: boolean = this.store.order_requirements?.is_enabled || false;
      const is_partially_enabled: boolean = this.store.order_requirements?.is_partially_enabled || false;
      const is_web_sale_enabled: boolean = this.store.order_requirements?.is_web_sale_enabled || false;
      const is_in_store_sale_enabled: boolean = this.store.order_requirements?.is_in_store_sale_enabled || false;

      this.store_order_requirements_from_group.get(this.form_service.is_enabled_label)?.setValue(is_enabled);
      this.store_order_requirements_from_group.get(this.form_service.is_partially_enabled_label)?.setValue(is_partially_enabled);
      this.store_order_requirements_from_group
        .get(this.form_service.is_web_sale_enabled_label)
        ?.setValue(is_web_sale_enabled);
      this.store_order_requirements_from_group
        .get(this.form_service.is_in_store_sale_enabled_label)
        ?.setValue(is_in_store_sale_enabled);

      if (is_enabled) {
        this.store_order_requirements_from_group
          .get(this.form_service.is_web_sale_enabled_label)
          ?.enable();
        this.store_order_requirements_from_group
          .get(this.form_service.is_in_store_sale_enabled_label)
          ?.enable();
      } else {
        this.store_order_requirements_from_group
          .get(this.form_service.is_web_sale_enabled_label)
          ?.disable();
        this.store_order_requirements_from_group
          .get(this.form_service.is_in_store_sale_enabled_label)
          ?.disable();
      }
    }
  }

  onToggleChange(changed_control_name: string): void {
    if (changed_control_name === 'is_enabled' || changed_control_name === 'is_partially_enabled') {
      Object.keys(this.store_order_requirements_from_group.controls).forEach(control_name => {
        if (control_name !== changed_control_name) {
          this.store_order_requirements_from_group.get(control_name)?.setValue(false);
        }
      });
    }
    if (changed_control_name === 'is_enabled' &&
      this.store_order_requirements_from_group.get(changed_control_name)) {
      this.store_order_requirements_from_group.get(this.form_service.is_web_sale_enabled_label)?.setValue(this.store_order_requirements_from_group.get(changed_control_name)?.value);
      this.store_order_requirements_from_group.get(this.form_service.is_in_store_sale_enabled_label)?.setValue(this.store_order_requirements_from_group.get(changed_control_name)?.value);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    const min_amount: number = this.store?.order_requirements?.min_amount || 20000;
    const max_amount: number = this.store?.order_requirements?.max_amount || 200000;
    const is_bnpl_long_enabled: boolean = this.store?.order_requirements?.is_bnpl_long_enabled || false;
    const is_sdd_payment_enabled: boolean = this.store?.order_requirements?.is_sdd_payment_enabled || false;

    const order_requirements = {
      ...this.stores_service.buildOrderRequirementsFromForm(this.store_order_requirements_from_group),
      min_amount,
      max_amount,
      is_bnpl_long_enabled,
      is_sdd_payment_enabled,
    };

    this.store?.store_id && this.setOrderRequirements(this.store.store_id, order_requirements);
  }

  setOrderRequirements(store_id: string, order_requirements: OrderCreationRequirements): void {
    this.is_enabling_running = true;
    this.stores_service.setOrderRequirements(store_id, order_requirements).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_enabling_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_enabling_running = false;
      },
    });
  }

  isStoreDisabled(): boolean {
    return this.store_order_requirements_from_group.get(this.form_service.is_enabled_label)?.value === false;
  }
}
